import mainDefaultIP from '../config.js';

const getToken = async (username, password) => {
  let defaultIP = mainDefaultIP;

  const storedIP = localStorage.getItem('zuta_defaultIP');
  if (storedIP) {
    console.log("storedIP", storedIP);
    defaultIP = storedIP;  // Update the local variable if a stored IP is found
  }
    
    console.log("defaultIP", defaultIP);
    try {
        const response = await fetch(`${defaultIP}oauth/token?grant_type=password&scope=datacenter&username=${username}&password=${password}`, {
            method: "POST",
            timeout: 0,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Basic Y2xpZW50OnNlY3JldA=="
            }
        });
  
      if (!response.ok) {
        console.log(response);
        throw new Error('Failed to get token');
      }


      const data = await response.json();

      console.log(data);
      if(data['access_token']){
        saveToken(data['access_token'], username);
      }

      return data; // Assuming the API responds with a token
    } catch (error) {
      console.log('Error:', error);
      return error;
    }
  };


  const saveToken = async (token, username) => {

        localStorage.setItem('uname', JSON.stringify(username));
        localStorage.setItem('zuta', JSON.stringify(token));

    }
  
  export default getToken;
  